import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Headercomponent } from '../components/headercomponent';
import NodeBackground from '../components/nodeBackground';
import '../css/CrimeMapGallery.css';
import { Footer } from '../components/Footer';
import DemoModal from '../components/demoModal';

const CITY_DATA_URL = '/data/cities.json';

const fallbackCities = [
  {
    id: 'washington-dc',
    cityName: 'Washington, D.C.',
    state: 'DC',
    slug: 'washington-dc',
    heroPhoto: '/data/city_photos/washington-dc.jpg',
    summary:
      'Reported crime in Washington, D.C. tends to concentrate around high-activity corridors, nightlife areas, transit nodes, commercial zones, and several neighborhood clusters east and northeast of the city center.',
    concentration: 'Downtown corridors, transit-adjacent areas, nightlife zones, and selected neighborhood clusters.',
    commonCrimeTypes: ['Theft from auto', 'Motor vehicle theft', 'Assault', 'Robbery', 'Burglary'],
    audienceNote:
      'Useful for travelers comparing hotel areas, home buyers evaluating neighborhood context, and protective teams planning movement across the city.',
    "photos": [
      {
        "url": "/data/DC/city_statistics.png",
        "title": "Crime Statistics for Washington D.C.",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/crime_trends.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/crime_types.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/georgetown_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/Georgetown_university_violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/overview_3d.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/trinidad_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/trinidad_violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/DC/violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      }

    ],
  },
  {
    id: 'chicago',
    cityName: 'Chicago',
    state: 'IL',
    slug: 'chicago',
    heroPhoto: '/data/city_photos/chicago.jpg',
    summary:
      'Chicago crime patterns are highly localized. Citywide totals can hide sharp differences between downtown, major commercial districts, transit corridors, and residential neighborhoods.',
    concentration: 'Commercial corridors, dense transit areas, entertainment districts, and historically higher-volume neighborhood clusters.',
    commonCrimeTypes: ['Theft', 'Battery', 'Motor vehicle theft', 'Burglary', 'Robbery'],
    audienceNote:
      'Useful for visitors choosing lodging, families comparing neighborhoods, and organizations planning employee travel or event operations.',
    photos: [
      {
        "url": "/data/Chicago/Austin_chicago_violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Chicago/Chicago_robberies.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Chicago/Lincoln_Park_Violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Chicago/overview_3d.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Chicago/violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      }
    ],
  },
  {
    id: 'los-angeles',
    cityName: 'Los Angeles',
    state: 'CA',
    slug: 'los-angeles',
    heroPhoto: '/data/city_photos/los-angeles.jpg',
    summary:
      'Los Angeles requires block-level context because crime can vary significantly by neighborhood, roadway, commercial center, and entertainment corridor.',
    concentration: 'Entertainment districts, retail corridors, transit-adjacent locations, parking-heavy areas, and selected neighborhood clusters.',
    commonCrimeTypes: ['Vehicle burglary', 'Theft', 'Assault', 'Robbery', 'Motor vehicle theft'],
    audienceNote:
      'Useful for travelers, production teams, executives, and home buyers comparing risk across a large metropolitan area.',
    photos: [
      {
        "url": "/data/LA/Brentwood_violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/LA/city_statistics.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/LA/crime_map.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/LA/overview_3D.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/LA/South_LA_Violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/LA/violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
    ],
  },
  {
    id: 'seattle',
    cityName: 'Seattle',
    state: 'WA',
    slug: 'seattle',
    heroPhoto: '/data/city_photos/seattle.jpg',
    summary:
      'Seattle crime analysis benefits from separating downtown, waterfront, commercial, residential, and transit-adjacent activity rather than relying on broad citywide averages.',
    concentration: 'Downtown, waterfront-adjacent areas, commercial corridors, parking areas, and transit-linked clusters.',
    commonCrimeTypes: ['Theft', 'Vehicle prowling', 'Assault', 'Burglary', 'Motor vehicle theft'],
    audienceNote:
      'Useful for visitors choosing hotel locations, employers assessing office area context, and buyers comparing residential neighborhoods.',
    photos: [
      {
        "url": "/data/Seattle/crime_statistics.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/crime_timeline.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/crime_trends.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/Downtown_seattle.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/overview_3D.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/Queen_anne_Violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Seattle/violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
    ]
  },
  {
    id: 'lynchburg-va',
    cityName: 'Lynchburg',
    state: 'VA',
    slug: 'lynchburg-va',
    heroPhoto: '/data/city_photos/lynchburg-va.jpg',
    summary:
      'Lynchburg crime patterns are more useful when reviewed by neighborhood, commercial area, and repeated location clusters instead of broad citywide totals.',
    concentration: 'Downtown, commercial areas, busier roadway corridors, and repeated incident locations.',
    commonCrimeTypes: ['Larceny', 'Assault', 'Drug-related offenses', 'Court order violations', 'Burglary'],
    audienceNote:
      'Useful for local home buyers, relocating families, property managers, and businesses reviewing neighborhood-level context.',
    photos: [
      {
        "url": "/data/Lynchburg/boonsboro.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/boonsboro_college_park_VC.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/college_park.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/crime_timeline.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/crime_types.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/lynchburg_statistics.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/overview_3d.png",
        "title": "example title",
        "description_text": "description text"
      },
      {
        "url": "/data/Lynchburg/violent_crime.png",
        "title": "example title",
        "description_text": "description text"
      },
    ],
  },
];

function buildGalleryItems(cities, selectedCity) {
  const sourceCities = selectedCity ? [selectedCity] : cities;

  return sourceCities.flatMap((city) =>
    city.photos.map((photo, index) => ({
      id: `${city.id}-${index}`,
      src: photo.url,
      cityId: city.id,
      cityName: city.cityName,
      state: city.state,
      title: photo.title || `${city.cityName} Crime Map View ${index + 1}`,
      description: photo.description_text || city.summary,
      concentration: city.concentration,
      commonCrimeTypes: city.commonCrimeTypes,
    }))
  );
}

function CrimeMapGallery() {
  const [cities, setCities] = useState(fallbackCities);
  const [selectedCityId, setSelectedCityId] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalItem, setModalItem] = useState(null);
  const galleryRef = useRef(null);
  const [showDemoModal, setShowDemoModal] = useState(false);

  useEffect(() => {
    fetch(CITY_DATA_URL)
      .then((response) => {
        if (!response.ok) throw new Error('City data not found');
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data?.cities) && data.cities.length > 0) {
          setCities(data.cities);
        }
      })
      .catch(() => {
        setCities(fallbackCities);
      });
  }, []);

  const selectedCity = useMemo(
    () => cities.find((city) => city.id === selectedCityId) || null,
    [cities, selectedCityId]
  );

  const galleryItems = useMemo(
    () => buildGalleryItems(cities, selectedCity),
    [cities, selectedCity]
  );

  useEffect(() => {
    setActiveIndex(0);

    if (selectedCityId && galleryRef.current) {
      requestAnimationFrame(() => {
        galleryRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    }
  }, [selectedCityId]);

  useEffect(() => {
    if (modalItem || galleryItems.length <= 1) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % galleryItems.length);
    }, 3600);

    return () => window.clearInterval(timer);
  }, [galleryItems.length, modalItem]);

  useEffect(() => {
    if (!modalItem) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        goToPreviousModalItem();
      }

      if (event.key === 'ArrowRight') {
        goToNextModalItem();
      }

      if (event.key === 'Escape') {
        setModalItem(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalItem, galleryItems]);

  const activeItem = galleryItems[activeIndex] || galleryItems[0];

  const handleImageClick = (item) => {
    const clickedCity = cities.find((city) => city.id === item.cityId);

    if (!selectedCity && clickedCity) {
      setSelectedCityId(clickedCity.id);
    }

    setModalItem(item);
  };

  const getModalIndex = () => {
    if (!modalItem) return -1;
    return galleryItems.findIndex((item) => item.id === modalItem.id);
  };

  const goToPreviousModalItem = () => {
    const currentIndex = getModalIndex();
    if (currentIndex === -1 || galleryItems.length === 0) return;

    const previousIndex =
      currentIndex === 0 ? galleryItems.length - 1 : currentIndex - 1;

    setModalItem(galleryItems[previousIndex]);
    setActiveIndex(previousIndex);
  };

  const goToNextModalItem = () => {
    const currentIndex = getModalIndex();
    if (currentIndex === -1 || galleryItems.length === 0) return;

    const nextIndex =
      currentIndex === galleryItems.length - 1 ? 0 : currentIndex + 1;

    setModalItem(galleryItems[nextIndex]);
    setActiveIndex(nextIndex);
  };
  const handleCityChange = (event) => {
    setSelectedCityId(event.target.value);
    setModalItem(null);
  };

  return (
    <>
      <Headercomponent />

      <main className="container crime-gallery-page">
        <section className="hero crime-gallery-hero">
          <NodeBackground />
          <div className="hero-content">
            <p className="eyebrow">Crime Map Gallery</p>
            <h1>City Crime Maps for Travelers, Home Buyers, and Protective Teams</h1>
            <p>
              Explore visual crime concentration snapshots by city. These maps are designed to make
              public safety patterns easier to understand before travel, relocation, property decisions,
              or protective planning. Request a customized crime and safety report for hotels, venues, events, properties, or travel routes in a specific city.
            </p>
            <div className="crime-gallery-controls">
              <label htmlFor="city-select">Select a city</label>
              <select id="city-select" value={selectedCityId} onChange={handleCityChange}>
                <option value="">All available cities</option>
                {cities.map((city) => (
                  <option value={city.id} key={city.id}>
                    {city.cityName}, {city.state}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="hero-diagram crime-gallery-hero-panel">
            <div className="gallery-preview-card">
              <span className="gallery-kicker">Rotating City Intelligence</span>
              <h3>{selectedCity ? `${selectedCity.cityName} Crime Snapshot` : 'Multi-City Crime Snapshot'}</h3>
              <p>
                {selectedCity
                  ? selectedCity.summary
                  : 'When no city is selected, the gallery rotates through available crime map views from each city in the dataset.'}
              </p>
              <div className="gallery-preview-tags">
                <span>Crime concentration</span>
                <span>Location context</span>
                <span>Custom reports available</span>
              </div>
            </div>
          </div>
        </section>

        <section className="crime-gallery-intro">
          <div>
            <p className="eyebrow">City-Level Context</p>
            <h2>{selectedCity ? `${selectedCity.cityName}, ${selectedCity.state}` : 'Browse Crime Patterns Across Cities'}</h2>
            <p>
              {selectedCity
                ? selectedCity.audienceNote
                : 'Select a city to focus the gallery, or browse rotating images from all available cities. Each city can be used as a starting point for a customized report covering hotel areas, venues, events, properties, travel routes, and neighborhood-level safety context.'}
            </p>
          </div>
          <div className="crime-insight-card">
            <h3>What to Look For</h3>
            <ul>
              <li>Repeated clusters around specific blocks, corridors, or venues.</li>
              <li>Differences between violent crime, property crime, and vehicle-related crime.</li>
              <li>Whether risk is citywide or concentrated in a small number of areas.</li>
              <li>How crime context may affect lodging, property, travel, or event decisions.</li>
            </ul>
          </div>
        </section>

        <section className="crime-report-cta">
          <div>
            <p className="eyebrow">Custom Crime and Safety Reports</p>
            <h2>Need location-specific context before you book, buy, host, or travel?</h2>
            <p>
              Request a customized report for a hotel, venue, event site, property, travel route, or neighborhood.
              Each report reviews crime patterns around the specific location and turns public safety data into
              practical decision support.
            </p>
          </div>
          <button
            className="crime-report-cta-button"
            type="button"
            onClick={() => {
              setModalItem(null);
              setShowDemoModal(true);
            }}
          >
            Request a Report
          </button>
        </section>

        {activeItem && (
          <section
            ref={galleryRef}
            className="rotating-gallery-section"
          >
            <div className="section-heading-row">
              <div>
                <p className="eyebrow">Visual Gallery</p>
                <h2>{selectedCity ? `${selectedCity.cityName} Crime Map Views` : 'Rotating Crime Map Views'}</h2>
              </div>
              <p className="gallery-status">
                {selectedCity ? 'City selected' : 'Showing all cities'} · {activeIndex + 1} of {galleryItems.length}
              </p>
            </div>

            <div className="crime-gallery-stage">
              <button className="gallery-main-image" onClick={() => handleImageClick(activeItem)} type="button">
                <img
                  src={activeItem.src}
                  alt={activeItem.title}
                  onError={(event) => {
                    event.currentTarget.src = '/data/city_photos/placeholder-city-map.jpg';
                  }}
                />
                <div className="gallery-image-overlay">
                  <span>{activeItem.cityName}, {activeItem.state}</span>
                  <h3>{activeItem.title}</h3>
                  <p>{activeItem.description}</p>
                  <span className="gallery-overlay-cta">Need this for a specific address, hotel, venue, or event?</span>
                </div>
              </button>

              <div className="gallery-analysis-panel">
                <h3>Analytical Snapshot</h3>
                <p>{activeItem.description}</p>
                <div className="analysis-block">
                  <span>Likely Concentration Areas</span>
                  <p>{activeItem.concentration}</p>
                </div>
                <div className="crime-type-pills">
                  {activeItem.commonCrimeTypes.map((crimeType) => (
                    <span key={crimeType}>{crimeType}</span>
                  ))}
                </div>
              </div>
            </div>

            <div className="thumbnail-strip">
              {galleryItems.slice(0, 10).map((item, index) => (
                <button
                  className={`gallery-thumbnail ${index === activeIndex ? 'active' : ''}`}
                  key={item.id}
                  onClick={() => {
                    setActiveIndex(index);
                    handleImageClick(item);
                  }}
                  type="button"
                >
                  <img
                    src={item.src}
                    alt={item.title}
                    onError={(event) => {
                      event.currentTarget.src = '/data/city_photos/placeholder-city-map.jpg';
                    }}
                  />
                  <span>{item.cityName}</span>
                </button>
              ))}
            </div>
          </section>
        )}

        <section className="city-content-grid">
          {cities.map((city) => (
            <article className="city-seo-card" key={city.id}>
              <img
                src={city.heroPhoto}
                alt={`${city.cityName} city crime map preview`}
                onError={(event) => {
                  event.currentTarget.src = '/data/city_photos/placeholder-city-map.jpg';
                }}
              />
              <div>
                <p className="eyebrow">{city.state} Crime Map</p>
                <h3>{city.cityName} Crime Analysis</h3>
                <p>{city.summary}</p>
                <button
                  className="text-button"
                  onClick={() => setSelectedCityId(city.id)}
                  type="button"
                >
                  View {city.cityName} Gallery →
                </button>
              </div>
            </article>
          ))}
        </section>

        <section className="crime-gallery-disclaimer">
          <h2>How to Use These Crime Maps</h2>
          <p>
            These gallery images are intended to provide general context, not a guarantee of safety or a
            complete risk assessment. Public crime data can vary by source, reporting practice, location
            accuracy, and update schedule. For a property, travel itinerary, venue, or executive movement
            decision, request a tailored report that reviews the exact location and decision context.
          </p>
        </section>
      </main>

      {modalItem && (
        <div className="crime-gallery-modal-overlay" onClick={() => setModalItem(null)} role="presentation">
          <div className="crime-gallery-modal" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
            <button className="crime-gallery-modal-close" onClick={() => setModalItem(null)} type="button" aria-label="Close gallery modal">
              ×
            </button>
            <button
              className="crime-gallery-modal-arrow crime-gallery-modal-arrow-left"
              type="button"
              onClick={goToPreviousModalItem}
              aria-label="Previous image"
            >
              ‹
            </button>

            <img
              src={modalItem.src}
              alt={modalItem.title}
              onError={(event) => {
                event.currentTarget.src = '/data/city_photos/placeholder-city-map.jpg';
              }}
            />

            <button
              className="crime-gallery-modal-arrow crime-gallery-modal-arrow-right"
              type="button"
              onClick={goToNextModalItem}
              aria-label="Next image"
            >
              ›
            </button>
            <div className="crime-gallery-modal-copy">
              <p className="eyebrow">{modalItem.cityName}, {modalItem.state}</p>
              <h2>{modalItem.title}</h2>
              <p>{modalItem.description}</p>
              <button
                className="modal-report-link"
                type="button"
                onClick={() => setShowDemoModal(true)}
              >
                Request a custom report for this city →
              </button>
            </div>
          </div>
        </div>
      )}
      <DemoModal
        isOpen={showDemoModal}
        onClose={() => setShowDemoModal(false)}
      />

      <Footer />
    </>
  );
}

export default CrimeMapGallery;
